import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMail = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M3.66675 20C3.21675 20 2.82642 19.8347 2.49575 19.5042C2.16525 19.1736 2 18.7833 2 18.3333V5.66675C2 5.21675 2.16525 4.82642 2.49575 4.49575C2.82642 4.16525 3.21675 4 3.66675 4H20.3333C20.7833 4 21.1736 4.16525 21.5043 4.49575C21.8348 4.82642 22 5.21675 22 5.66675V18.3333C22 18.7833 21.8348 19.1736 21.5043 19.5042C21.1736 19.8347 20.7833 20 20.3333 20H3.66675ZM12 12.6332L20.3333 7.25V5.66675L12 10.9667L3.66675 5.66675V7.25L12 12.6332Z",
		fill: "#005FFF"
	})]
});
const ForwardRef = forwardRef(SvgMail);
export default ForwardRef;
